import { fromJS } from "immutable";
import ACTIONS from "../constants";

const initialState = fromJS({
  error: "",
  pageLoading: false,
  decisionLogLoading: false,
  decisionLogs: [],
  decisionLogsPagination: {},
});

export default function decisionLogReducers(state = initialState, action) {
  switch (action.type) {
    // DecisionLog sorting
    case ACTIONS.SORT_DECISION_LOG.PENDING: {
      return state.set("error", "").set("pageLoading", true);
    }
    case ACTIONS.SORT_DECISION_LOG.SUCCESS: {
      return state
        .set("pageLoading", false)
        .set("error", "")
        .set("decisionLogs", action.data.data)
        .set("decisionLogsPagination", action.data.pagination);
    }
    case ACTIONS.SORT_DECISION_LOG.ERROR: {
      return state.set("pageLoading", false).set("error", action.error);
    }

    // DecisionLog listing
    case ACTIONS.DECISION_LOG.PENDING: {
      return state.set("error", "").set("pageLoading", true);
    }
    case ACTIONS.DECISION_LOG.SUCCESS: {
      return state
        .set("pageLoading", false)
        .set("error", "")
        .set("decisionLogs", action.data.data)
        .set("decisionLogsPagination", action.data.pagination);
    }
    case ACTIONS.DECISION_LOG.ERROR: {
      return state.set("pageLoading", false).set("error", action.error);
    }

    // Create DecisionLog
    case ACTIONS.CREATE_DECISION_LOG.PENDING: {
      return state.set("decisionLogLoading", true).set("error", "");
    }
    case ACTIONS.CREATE_DECISION_LOG.SUCCESS: {
      return state
        .set("decisionLogLoading", false)
        .set("error", "")
        .set("decisionLogs", action.data.data)
        .set("decisionLogsPagination", action.data.pagination);
    }
    case ACTIONS.CREATE_DECISION_LOG.ERROR: {
      return state
        .set("error", action.error)
        .set("decisionLogLoading", false);
    }

    // Update DecisionLog
    case ACTIONS.UPDATE_DECISION_LOG.PENDING: {
      return state.set("decisionLogLoading", true).set("error", "");
    }
    case ACTIONS.UPDATE_DECISION_LOG.SUCCESS: {
      return state
        .set("decisionLogLoading", false)
        .set("error", "")
        .set("decisionLogs", action.data.data)
        .set("decisionLogsPagination", action.data.pagination);
    }
    case ACTIONS.UPDATE_DECISION_LOG.ERROR: {
      return state
        .set("error", action.error)
        .set("decisionLogLoading", false);
    }

    // Delete DecisionLog
    case ACTIONS.DELETE_DECISION_LOG.PENDING: {
      return state.set("decisionLogLoading", true).set("error", "");
    }
    case ACTIONS.DELETE_DECISION_LOG.SUCCESS: {
      return state
        .set("decisionLogLoading", false)
        .set("error", "")
        .set("decisionLogs", action.data.data)
        .set("decisionLogsPagination", action.data.pagination);
    }
    case ACTIONS.DELETE_DECISION_LOG.ERROR: {
      return state
        .set("error", action.error)
        .set("decisionLogLoading", false);
    }

    // Flag DecisionLog
    case ACTIONS.DECISION_LOG_FLAG.PENDING: {
      return state.set("decisionLogLoading", true).set("error", "");
    }
    case ACTIONS.DECISION_LOG_FLAG.SUCCESS: {
      return state
        .set("decisionLogLoading", false)
        .set("error", "")
        .set("decisionLogs", action.data.data)
        .set("decisionLogsPagination", action.data.pagination);
    }
    case ACTIONS.DECISION_LOG_FLAG.ERROR: {
      return state
        .set("error", action.error)
        .set("decisionLogLoading", false);
    }

    default:
      return state;
  }
} 